import { CheckoutErrorCodes } from '../../constants/checkout-error-codes';

export const handleOrderError = (e: { dhlCode?: string; message?: string }) => {
	if (e?.dhlCode) {
		return Promise.reject({
			code: CheckoutErrorCodes.DhlError,
		});
	}

	if (e?.message?.startsWith('destination_address')) {
		return Promise.reject({
			code: CheckoutErrorCodes.AddressError,
		});
	}

	if (e?.message?.startsWith('This order has already been processed')) {
		return Promise.reject({
			code: CheckoutErrorCodes.OrderAlreadyProcessed,
		});
	}

	if (
		e?.message &&
		[
			"Sorry, we couldn't find any shipping solutions based on the information provided.",
			'Cannot ship more than 50 items using DHL.',
			'No shipping solutions available based on the information provided',
		].includes(e?.message)
	) {
		return Promise.reject({
			code: CheckoutErrorCodes.QuantityError,
		});
	}

	if (
		e?.message?.startsWith?.(
			'The given wallet address did not pass the KYT check'
		)
	) {
		return Promise.reject({
			code: CheckoutErrorCodes.ChainalysisError,
		});
	}

	if (
		e?.message?.startsWith?.(
			'The order cannot not be completed as there is insufficient stock for the following product(s)'
		)
	) {
		return Promise.reject({
			code: CheckoutErrorCodes.StockError,
			message: e?.message,
		});
	}

	return Promise.reject({ code: CheckoutErrorCodes.GenericError });
};
